module.exports = __webpack_public_path__ + "files/cec0fe5ed5461875aaa25984d4a04e6f.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-6.png
// module id = 535
// module chunks = 76